module.exports = __webpack_public_path__ + "img/antes_despues_279.5b285e98.png";